// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalCopayDto
 */
export interface IRenewalCopayDto {
    /**
     * 
     * @type {string}
     * @memberof IRenewalCopayDto
     */
    category_type?: IRenewalCopayDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalCopayDto
     */
    amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalCopayDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IRenewalCopayDto interface.
 */
export function instanceOfIRenewalCopayDto(value: object): value is IRenewalCopayDto {
    return true;
}

export function IRenewalCopayDtoFromJSON(json: any): IRenewalCopayDto {
    return IRenewalCopayDtoFromJSONTyped(json, false);
}

export function IRenewalCopayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalCopayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IRenewalCopayDtoToJSON(json: any): IRenewalCopayDto {
    return IRenewalCopayDtoToJSONTyped(json, false);
}

export function IRenewalCopayDtoToJSONTyped(value?: IRenewalCopayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'amount': value['amount'],
    };
}

